$shm_check_list_only $mol_list
	options /string
	value? /string
	toggles /$mol_check
	only_title \Только
	only_visible true
	inline false
	attr *
		^
		shm_check_list_only_inline <= inline
	rows /
		<= All $shm_check_all
			title \Все
			checks <= toggles
		<= Checks $mol_list
			rows <= checks /
	Check* $mol_view
		sub <= check_content* /
	Toggle* $mol_check_box
		title <= check_title* \
		checked? <=> checked*? false
	Only* $mol_button_minor
		title <= only_title
		click? <=> only*? null
